import React from "react";

const Acceptance = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        A.
        <span className="text-[#01A7D1] "> ACCEPTANCE OF TERMS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          PLEASE READ THE TERMS OF USE THOROUGHLY AND CAREFULLY.
        </h1>
        All references to "you" or "your" or “user” as applicable, mean the
        person that accesses, uses, and/or participates in the Platform in any
        manner. “you” or “your” or “user” would include the parent and/or
        guardian of such a minor and the parent and/or guardian. In the event
        any person who accesses, uses and/or participates in the Platform is a
        minor (i.e. less than 18 years of age) then such individual shall be
        obligated to cause and procure the minor to adhere to the obligations as
        set out hereunder.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The terms and conditions set forth below ("Terms of Use") and the
        Privacy Policy (as defined below) constitute a legally binding agreement
        between Yostel and you. These Terms of Use contain provisions that
        define your limits, legal rights and obligations with respect to your
        use of and participation in the Yostel Platform, including the
        classified advertisements, forums, various email functions and Internet
        links, and all content and Yostel services available through Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Currently the services pertain to five broad sections, which are (i)
        Feedback, (ii) Check Ins, (iii) Complaint Management, (iv) Social and
        (v) Yostel Mates (such services, collectively, the "Services"). Yostel
        reserves the right to add or remove any services at any time on such
        terms as it deems fit. The Terms of Use described below incorporate the
        Privacy Policy and apply to all users of the Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You acknowledge that the Platform serves as a venue for the online
        distribution and publication of user submitted information between
        various users, and, by using, visiting, registering for, and/or
        otherwise participating in this Platform, including the Services
        presented, promoted, and displayed on the Platform, and by clicking on
        "I have read and agree to the terms of use”, you hereby certify that:
        (1) you are duly registered with Yostel in case you are using the App,
        (2) you have the authority to enter into these Terms of Use, (3) you
        agree to be bound by all terms and conditions of these Terms of Use and
        any other documents incorporated by reference herein. If you do not so
        agree to the foregoing, you should not click to affirm your acceptance
        thereof, in which case you are prohibited from accessing or using the
        Platform. If you do not agree to any of the provisions set forth in the
        Terms of Use, kindly discontinue viewing or participating in this
        Platform immediately.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <span className="text-lg  font-medium">
          {" "}
          YOU SPECIFICALLY AGREE THAT BY USING THE PLATFORM, YOU ARE EITHER (i)
          AT LEAST 18 YEARS OF AGE AND OF SOUND MIND AND YOU ARE COMPETENT UNDER
          LAW TO ENTER INTO A LEGALLY BINDING AND ENFORCEABLE CONTRACT OR (ii)
          ARE THE PARENT AND/OR GUARDIAN OF THE MINOR USING THE PLATFORM, AND
          YOU ARE COMPETENT UNDER LAW TO ENTER INTO A LEGALLY BINDING AND
          ENFORCEABLE CONTRACT ON BEHALF OF THE MINOR AND THE SAID MINOR SHALL
          BE BOUND BY THE SAME.
        </span>
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Modifications to Terms of Use and /or Privacy Policy
        </h1>
        1. Modifications to Terms of Use and /or Privacy Policy Yostel reserves
        the right, in its sole discretion, to change, modify, or otherwise amend
        the Terms of Use, and any other documents incorporated by reference
        herein for complying with legal and regulatory framework and for other
        legitimate business purposes, at any time, without notice and Yostel
        will post the amended Terms of Use at the domain of
        http://yostelhostel.com/terms-and-conditions . It is your responsibility
        to review the Terms of Use for any changes and you are encouraged to
        check the Terms of Use frequently. Your use of the Platform following
        any amendment of the Terms of Use will signify your assent to and
        acceptance of any revised Terms of Use. If you do not agree to abide by
        these or any future Terms of Use, please do not use or access the
        Platform.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Privacy Policy
        </h1>
        Yostel has established a Privacy Policy that explains to users how their
        information is collected and used. The Privacy Policy is referenced
        above and hereby incorporated into the Terms of Use set forth herein.
        Your use of this Platform is governed by the Privacy Policy, you may
        refer to the Privacy Policy for any grievances related to the
        collection, storage and use of any Sensitive Personal Data and Personal
        Data as defined under Information Technology (Reasonable security
        practices and procedures and sensitive personal data or information)
        Rules, 2011.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The Privacy Policy is located at:
        https://yostelhostel.com/privacy-policy
      </p>
    </div>
  );
};

export default Acceptance;
